import {
  ENVIRONMENT_NAME,
  HONEY_BADDGER_API_KEY,
  AUTH_USER_POOL_ID,
  AUTH_AUD,
  AUTH_DOMAIN
} from "./globalVars";
import Vue from "vue";

import App from "./App.vue";
import router from "./router";
import plugins from "./plugins/plugins";
import store from "./store/store";

import Amplify, * as AmplifyModules from "aws-amplify";
import { AmplifyPlugin } from "aws-amplify-vue";
// import awsconfig from "./aws-exports";

import vuetify from "./plugins/vuetify";

// Amplify.configure(awsconfig);
Amplify.configure({
  Auth: {
    region: "us-east-1",
    userPoolId: AUTH_USER_POOL_ID,
    userPoolWebClientId: AUTH_AUD,
    oauth: {
      domain: AUTH_DOMAIN,
      scope: ["phone", "email", "openid", "profile"],
      redirectSignIn: `http://${window.location.hostname}:8080/,https://app.dabaone.com/`,
      redirectSignOut: "https://www.dabaone.com/",
      responseType: "code"
    },
    federationTarget: "COGNITO_USER_POOLS"
  }
});
Vue.use(AmplifyPlugin, AmplifyModules);

import HoneybadgerVue from "@honeybadger-io/vue";
const config = {
  apiKey: HONEY_BADDGER_API_KEY,
  environment: ENVIRONMENT_NAME,
  revision: "0.0.1",
  maxErrors: 10
};
Vue.use(HoneybadgerVue, config);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  plugins,
  vuetify,
  render: h => h(App)
}).$mount("#app");
